import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/referral/banner-referal.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text-right flex" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "self-end w-full",
    src: _imports_0,
    alt: "banner-referral",
    id: "banner-referral"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-full",
  alt: "banner-referral"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mt-4 px-1 text-14px" }, " Ajak teman Anda bergabung menjadi Agen Mitra POS Lion Parcel dengan menggunakan kode referral dan dapatkan insentif jika memenuhi syarat dan ketentuan. ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mt-4 px-1 text-14px" }, " Bagikan kode referral ini dan ajak teman Anda bergabung menjadi Agen Mitra POS Lion Parcel. ", -1)
const _hoisted_5 = { class: "text-center mt-6" }
const _hoisted_6 = { class: "inline-block relative mr-4 text-12px xxl:text-14px" }
const _hoisted_7 = { class: "\n              absolute\n              inset-y-0\n              right-0\n              flex\n              items-center\n              px-5\n              bg-gray-lp-200\n              rounded-r\n            " }
const _hoisted_8 = { class: "text-14px mt-6 px-1" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "font-bold mt-6" }, "Syarat dan Ketentuan:", -1)
const _hoisted_10 = { class: "pl-6 mt-3" }
const _hoisted_11 = { class: "mt-6 flex items-center justify-center" }
const _hoisted_12 = { class: "p-4 cursor-pointer border rounded" }
const _hoisted_13 = { class: "flex flex-row w-full" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "w-8/12 pl-3 text-14px self-center" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-bold" }, "Daftar Sekarang!")
], -1)
const _hoisted_15 = { class: "w-4/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_referral_modal = _resolveComponent("referral-modal")!
  const _component_SnackbarCopy = _resolveComponent("SnackbarCopy")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleReferalDialog(true))),
      class: "mt-2 w-full bg-white rounded relative cursor-pointer overflow-hidden"
    }, [
      _hoisted_1
    ]),
    (_ctx.referralDialogModelValue)
      ? (_openBlock(), _createBlock(_component_referral_modal, {
          key: 0,
          title: "POS Referral",
          showFooter: false,
          width: "w-6/12",
          onClose: _ctx.onCloseModal
        }, {
          content: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("input", {
                  value: _ctx.referralCode,
                  disabled: "",
                  class: "\n              text-red-lp-300\n              font-bold\n              text-20px\n              block\n              appearance-none\n              bg-white\n              border border-gray-lp-400\n              pl-3\n              py-3\n              rounded\n              leading-tight\n              focus:outline-none\n            "
                }, null, 8, ["value"]),
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_Icons, {
                    name: "auto-copy",
                    onClick: _ctx.autoCopy,
                    class: "text-red-lp-100 cursor-pointer"
                  }, null, 8, ["onClick"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createVNode("div", _hoisted_10, null, 512), [
                [_directive_sanitize_html, _ctx.term]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("a", {
                  href: 
              `https://lionparcel.com/agen/perorangan-app?referral=${this.referralCode}`
            ,
                  target: "_blank",
                  rel: "noopener"
                }, [
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode("div", _hoisted_15, [
                      _createVNode("img", {
                        src: 
                    require(`@/app/ui/assets/svg/referral/referral-register-icon.svg`)
                  ,
                        class: "w-full",
                        alt: "referral-register-icon"
                      }, null, 8, ["src"])
                    ])
                  ])
                ], 8, ["href"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_SnackbarCopy, {
      "model-value": _ctx.copyNotification,
      "onUpdate:modelValue": _ctx.removeCopyNotification
    }, null, 8, ["model-value", "onUpdate:modelValue"])
  ], 64))
}